import { useQuery } from '@tanstack/react-query';
import { useHistory, useLocation } from 'react-router-dom';
import React, { useMemo } from 'react';
import * as qs from 'qs';
import Spinner from '../../components/layout/Spinner';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import api from '../../domain/api';
import { PAGE_TITLE } from '../../shared/enums/clients_enum';
import ClientDashboardView from './_components/client-dashboard-view';

const ClientDashboard = ({ match }) => {
  const history = useHistory();
  const location = useLocation();

  // Parse query parameters
  const queryParams = useMemo(() => {
    return qs.parse(location.search.replace('?', ''));
  }, [location.search]);

  // Fetch optimized client dashboard data
  const {
    data: dashboardData,
    isLoading: dashboardLoading,
    refetch: refetchDashboard,
  } = useQuery({
    queryKey: ['client_optimized_dashboard', match.params.id, queryParams],
    queryFn: async () => {
      const query = qs.stringify(queryParams, { encodeValuesOnly: true });
      const resp = await api.get(
        `/clients/dashboard/${match.params.id}?${query}`
      );
      return resp.data;
    },
    keepPreviousData: true,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });

  // Handle filter changes
  const handleFilterChange = (filters) => {
    const query = qs.stringify(filters, { encodeValuesOnly: true });
    history.push(`${location.pathname}?${query}`);
  };

  const handleBack = () => {
    history.push('/clients');
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={`${dashboardData?.client?.name || 'Client'} Dashboard`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl='clients'
          activeLink='Dashboard'
        />

        {!dashboardLoading ? (
          dashboardData && (
            <ClientDashboardView
              dashboardData={dashboardData}
              onFilterChange={handleFilterChange}
              onBack={handleBack}
              onRefresh={refetchDashboard}
              queryParams={queryParams}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientDashboard;
